module.exports = __webpack_public_path__ + "img/img_page_03_01.64fa1ad6.png";